<template>
    <div>
        <div class="headline">Напрямки науково-педагогічної діяльності</div>
        <v-data-table
                :headers="headers"
                :items="items"
                :server-items-length="total"
                :loading="loading"
                :options.sync="pagination"
                class="elevation-3"
                hide-default-footer
        >
            <template v-slot:item.navigation="{item}">
                <div class="justify-start d-flex">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="$emit('navigateTo', item.id, 'ratingDirectionsStatDirection')" v-on="on" icon class="mx-0">
                                <v-icon color="green">send</v-icon>
                            </v-btn>
                        </template>
                        <span>Перейти до списку напрямків рейтингування</span>
                    </v-tooltip>
                </div>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    export default {
        props: {
            items: {
                type: Array,
            },
            total: {
                type: Number,
            },
            loading: {
                type: Boolean,
            },
        },
        watch: {
            pagination(paginationVal, prevPaginationVal) {
                this.$emit("paginate", paginationVal);
            },
        },
        data: () => ({
            pagination: {
                totalItems: 0,
            },
            headers: [
                {text: 'Навігація', value: 'navigation', sortable: false, width: "10%"},
                {text: 'Назва', value: 'directionName', sortable: false,},
                {text: 'Порядковий номер', value: 'order', sortable: false,},
                {text: 'Коефіцієнт', value: 'ratio', sortable: false,},
                {text: 'Сума балів', value: 'pointsSum', sortable: false,},
                {text: 'Сума балів * k', value: 'pointsSumRatio', sortable: false,},
            ],
        }),
    }
</script>